import inViewport from '@resources/js/helpers/inViewport'
import generateRating from '@resources/js/helpers/generate-rating.js'

const reviewsContainer = document.querySelector('.js-reviews-section')

inViewport(reviewsContainer, () => {
    const raitingAverageEl = reviewsContainer.querySelector('.js-average-rating')
    if (!raitingAverageEl) return

    const averageRating = raitingAverageEl.dataset.average
    const theme = raitingAverageEl.dataset.theme
    reviewsContainer.querySelector('.js-rating-stars').innerHTML = generateRating(averageRating, theme)
})
